import React from "react";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import capitalize from "lodash/capitalize";
// NOTE: reusing styles from StatusChange
import styles from "../../../editor/components/StatusChange/StatusChange.css";
import TakeoverPanel from "components/library/TakeoverPanel";
import TakeoverHeader from "components/library/TakeoverHeader";
import Button from "components/library/Button";
import Spinner from "components/library/Spinner";
import {
  updateDeepDiveFormAt,
  saveDeepDiveForm,
  publishDeepDiveFormAsync,
  unpublishDeepDiveFormAsync,
  deleteDeepDiveFormAsync,
  hydrateDeepDiveForm,
} from "deepDiveEditor/actions/form";
import { setMessage } from "actions/message";

class DeepDiveStatusChange extends React.Component {
  constructor(props) {
    super(props);
    this.closeEditor = this._closeEditor.bind(this);
    this.catchError = this._catchError.bind(this);
    this.renderInfo = this._renderInfo.bind(this);
    this.saveAndPublish = this._saveAndPublish.bind(this);
    this.changeStatus = this._changeStatus.bind(this);
    this.onClickAction = this._onClickAction.bind(this);

    this.state = {
      wasClicked: false,
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.props.hydrateDeepDiveForm(this.props.match.params.id);
    }
  }

  _closeEditor() {
    this.props.history.go(-1);
  }

  _catchError(error) {
    this.props.setMessage({ message: error });
    this.setState({ wasClicked: false });
  }

  _saveAndPublish(id) {
    this.props.updateDeepDiveFormAt("published_date", new Date().toISOString());
    return this.props
      .saveDeepDiveForm(true)
      .then(() => this.props.publishDeepDiveFormAsync(id));
  }

  _changeStatus({ actionFn, nextPage, message, messageType }) {
    this.setState({ wasClicked: true });
    return id =>
      actionFn(id)
        .then(() => {
          this.props.history.push(nextPage);
          this.props.setMessage({
            message,
            type: messageType,
          });
        })
        .catch(this.catchError);
  }

  _renderInfo(action) {
    const defaults = {
      cancel: "No, cancel",
      cta: `Yes, ${action} it`,
      "aria-label": `${capitalize(action)} the specified deep dive`,
      confirm: `Are you sure you want to ${action} this deep dive?`,
      nextPage: "/dashboard",
      messageType: "info",
    };
    const statusInfo = {
      publish: {
        actionFn: this.saveAndPublish,
        nextPage: "/dashboard/published",
        message: "Your deep dive has been published.",
        messageType: "success",
      },
      unpublish: {
        actionFn: this.props.unpublishDeepDiveFormAsync,
        message: "Your deep dive has been unpublished.",
      },
      delete: {
        "aria-label": "Delete the specified draft",
        confirm: "Are you sure you want to delete this draft?",
        actionFn: this.props.deleteDeepDiveFormAsync,
        message: "Your draft has been deleted.",
      },
      update: {
        confirm: "Update this deep dive?",
        actionFn: this.saveAndPublish,
        nextPage: "/dashboard/published",
        message: "Your deep dive has been updated.",
        messageType: "success",
      },
    };

    return { ...defaults, ...statusInfo[action] };
  }

  _onClickAction(action) {
    return this.changeStatus(this.renderInfo(action))(
      this.props.match.params.id
    );
  }

  render() {
    const { id, action } = this.props.match.params;
    const statusInfo = this.renderInfo(action);

    return (
      <TakeoverPanel
        containerStyle={styles.container}
        className={styles.takeoverPanel}
      >
        <TakeoverHeader>{statusInfo.confirm}</TakeoverHeader>
        {this.props.isLoading ? (
          <div className={styles.loading}>
            <Spinner />
          </div>
        ) : (
          <div>TK deep dive preview: {id}</div>
        )}
        <div className={styles.buttonGroup}>
          <Button
            onClick={() => this.onClickAction(action)}
            type="submit"
            data-cy="deepDiveActionButton"
            aria-label={statusInfo["aria-label"]}
            isDisabled={this.state.wasClicked}
          >
            {statusInfo.cta}
          </Button>

          <Button
            role="link"
            onClick={this.closeEditor}
            type="cancel"
            aria-label={`Cancel ${action} and go back to the previous page`}
          >
            {this.state.wasClicked ? "Close" : statusInfo.cancel}
          </Button>
        </div>
      </TakeoverPanel>
    );
  }
}

const mapStateToProps = state => ({
  form: state.editor.form,
  isLoading: state.editor.ui.isLoading,
});

const mapDispatchToProps = {
  saveDeepDiveForm,
  publishDeepDiveFormAsync,
  unpublishDeepDiveFormAsync,
  deleteDeepDiveFormAsync,
  updateDeepDiveFormAt,
  hydrateDeepDiveForm,
  setMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeepDiveStatusChange);

DeepDiveStatusChange.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  hydrateDeepDiveForm: PropTypes.func.isRequired,
  saveDeepDiveForm: PropTypes.func.isRequired,
  publishDeepDiveFormAsync: PropTypes.func.isRequired,
  unpublishDeepDiveFormAsync: PropTypes.func.isRequired,
  deleteDeepDiveFormAsync: PropTypes.func.isRequired,
  updateDeepDiveFormAt: PropTypes.func.isRequired,
  setMessage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
